import Decimal from 'decimal.js'

export default {
  data() {
    return {
      showInput: true,
    }
  },
  methods: {
    /**
     * Flag indicating if the input value requires to be adjusted initially. Either because it is a
     * field that needs to be localised according to the users locale
     * For example, a number 1234.56 in German locale should be presented as 1.234,56
     * Or because it is a field which contains more than one value to be saved as a result, like
     * ConvertibleDecimalInput
     * @returns {boolean}
     */
    inputRequiresInitialAdjustment() {
      return false
    },
    /**
     * Method validates input against common validation rules applicable to all sustainability
     * inputs
     * @returns {string|boolean} string with an error text in case validation failed
     * false otherwise
     */
    isInvalidAgainstCommonRules() {
      if (this.previouslySaved && this.isEmptyInput()) {
        return this.$t('valueIsRequired')
      }
      // short circuiting so that input specific validation rules are not evaluated
      return !!this.isEmptyInput()
    },
    isEmptyInput() {
      return !this.inputValue
    },
    /**
     * Formats a number to given number of places
     */
    formatForConvertedSustainabilityMetric(value, locale) {
      if (!this.isFloat(value)) {
        return ''
      }
      const decimalPlaces = this._maxDecimalPlaces(value)
      return value.toLocaleString(locale, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      })
    },
    updateValue(value) {
      this.formValues[this.item.id] = value
    },
  },
  computed: {
    inputValueToCompare() {
      if (this.inputValue) {
        return new Decimal(this.inputValue).toNumber()
      }
      return undefined
    },
  },
  watch: {
    contextValidationMessage() {
      this.$refs.input.validate()
    },
  },
}
